import React from "react";
import styled from "styled-components";

import { ADD_OR_EDIT_SPENDING } from "../../../../core/modal/modal-id";
import { WhiteModalContainer } from "../../../common/modal/white-modal-container";

export interface AddSpendingModalProps {
  children: React.ReactNode;
}

export const AddSpendingModal = (props: AddSpendingModalProps) => {
  const { children } = props;

  return (
    <ModalContainer closeButton id={ADD_OR_EDIT_SPENDING}>
      {children}
    </ModalContainer>
  );
};

const ModalContainer = styled(WhiteModalContainer)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 460px;
`;
